
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderOutstandingReportDialog extends Serenity.EntityDialog<OrderOutstandingReportRow, any> {
        protected getFormKey() { return OrderOutstandingReportForm.formKey; }
        protected getIdProperty() { return OrderOutstandingReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderOutstandingReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderOutstandingReportRow.nameProperty; }
        protected getService() { return OrderOutstandingReportService.baseUrl; }
        protected getDeletePermission() { return OrderOutstandingReportRow.deletePermission; }
        protected getInsertPermission() { return OrderOutstandingReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderOutstandingReportRow.updatePermission; }

        protected form = new OrderOutstandingReportForm(this.idPrefix);

    }
}